export default __webpack_public_path__ + "static/media/bg-green-top.e136872b.png";